/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { useIntl } from 'react-intl-next';
import { fontFallback } from '@atlaskit/theme/typography';
import { CrystalBallSVGOld } from './assets/crystal-ball-svg-old';
import { initialStateViewMessages } from './messages';
var initialStateViewContainerStyles = css({
  display: 'flex',
  justifyContent: 'center',
  height: '100%'
});
var svgAndTextsWrapperStyles = css({
  textAlign: 'center',
  alignSelf: 'center'
});
var searchTitleStyles = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
  font: "var(--ds-font-heading-small, ".concat(fontFallback.heading.small, ")"),
  paddingTop: "var(--ds-space-200, 16px)",
  paddingBottom: "var(--ds-space-100, 8px)"
});
var AQLSupportDocumentLink = 'https://support.atlassian.com/jira-service-management-cloud/docs/use-assets-query-language-aql/';
export var InitialStateViewOld = function InitialStateViewOld() {
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return jsx("div", {
    css: initialStateViewContainerStyles,
    "data-testid": "assets-aql-datasource-modal--initial-state-view"
  }, jsx("div", {
    css: svgAndTextsWrapperStyles
  }, jsx(CrystalBallSVGOld, null), jsx("div", {
    css: searchTitleStyles
  }, formatMessage(initialStateViewMessages.searchTitle)), jsx("div", null, formatMessage(initialStateViewMessages.searchDescription)), jsx("a", {
    href: AQLSupportDocumentLink,
    target: "_blank"
  }, formatMessage(initialStateViewMessages.learnMoreLink))));
};